export default {
  name: 'b2bAccessToken',
};



// WEBPACK FOOTER //
// ./src/ContentConfig/cookie.js